export default class UiConstants {
	static BTN_SPIN = 'ui_btn_spin';
	static BTN_STOP = 'ui_btn_stop';
	static BTN_MINUS = 'ui_btn_minus';
	static BTN_PLUS = 'ui_btn_plus';
	static BTN_LEFT = 'ui_btn_left';
	static BTN_RIGHT = 'ui_btn_right';
	static BTN_AUTO = 'ui_btn_auto';
	static BTN_FASTPLAY = 'ui_btn_fastplay';
	// static BTN_FULLSCREEN = "ui_fullscreen"
	static BTN_SOUND_ON = 'ui_sound_on';
	static BTN_SOUND_OFF = 'ui_sound_off';
	static BTN_SETTINGS = 'ui_settings';
	static BTN_INFO = 'ui_info';
	static FTR_BONUS_BY = 'ui_ftr_bonus_by';
	static FTR_BONUS_REVIVE = 'ui_ftr_bonus_revive';
	static FTR_DOUBLE_CHANCE = 'ui_ftr_double_chance';
	static FTR_QUEST = 'ui_ftr_quest';
	static FTR_QUEST_CLAIM = 'ui_ftr_quest_claim';
	static FTR_QUEST_CLAIMED = 'ui_ftr_quest_claimed';
	static FTR_QUEST_GO = 'ui_ftr_quest_go';
	static FTR_QUEST_CLOSE = 'ui_ftr_quest_close';
	static SPLASH_SCREEN_CHECKBOX = 'ui_splash_screen_checkbox';
	static SPLASH_SCREEN_BTN = 'ui_splash_screen_btn';
}
